var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftteams = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#485BD5",
  d: "M21.8 10.1H16v5.8c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5v-4.6c0-.7-.5-1.2-1.2-1.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6D81FF",
  d: "M6.8 10.1v7c0 2.9 2.3 5.5 5.4 5.7 3.4.2 6.2-2.3 6.2-5.5v-6.1c0-.6-.5-1.1-1.2-1.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5161CB",
  d: "M12.6 2c-1.2 0-2.4.7-3 1.7s-.6 2.4 0 3.5 1.8 1.7 3 1.7 2.4-.7 3-1.7.6-2.4 0-3.5-1.8-1.7-3-1.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3440A0",
  d: "M19.5 3.2c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3-1-2.3-2.3-2.3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D399A",
  d: "M11.6 18.2H2c-.5 0-1-.4-1-.9V8.7c0-.5.4-.9 1-.9h9.6c.5 0 1 .4 1 .9v8.7c0 .4-.5.8-1 .8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.1 10.1H4.5v1h1.7v4.8h1.2v-4.8h1.7z"
}))));
export { SvgMicrosoftteams as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoftteams.46a3e2a8.svg";